import Grid from '@/global/components/ui/Grid'
import dayjs from 'dayjs'
import { CardRadioForm, FormDatePicker } from 'global/components/Form'
import { SelectFuncionarios } from 'global/components/Selects'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useEffect } from 'react'
import { SubmitHandler, useFormContext } from 'react-hook-form'
import {
    CreateEspelhoPeriodo,
    CreateEspelhoPeriodoSchema,
    espelhoPeriodo,
} from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'

function Formulario() {
    const competencia = useStore(state => state.competencia)
    const { setValue } = useFormContext()

    useEffect(() => {
        const date = dayjs(competencia, 'YYYY-MM').set('date', 1)

        setValue('dataInicial', date.format('YYYY-MM-DD'))
        setValue('dataFinal', date.endOf('month').format('YYYY-MM-DD'))
    }, [competencia, setValue])

    return (
        <Grid container>
            <Grid item xs={12}>
                <CardRadioForm
                    name="formato"
                    label="Formato do arquivo"
                    options={[
                        {
                            value: 'zip',
                            titulo: 'ZIP',
                            descricao:
                                'Um PDF por funcionário, compactados num único arquivo.',
                        },
                        {
                            value: 'pdf',
                            titulo: 'PDF',
                            descricao:
                                'Todos os funcionários num único PDF, um após o outro.',
                        },
                    ]}
                />
            </Grid>
            <Grid item xs={6}>
                <FormDatePicker
                    name="dataInicial"
                    label="Data inicial"
                    type="date"
                />
            </Grid>
            <Grid item xs={6}>
                <FormDatePicker
                    name="dataFinal"
                    label="Data final"
                    type="date"
                />
            </Grid>
            <Grid item xs={12}>
                <SelectFuncionarios variant="form" form="funcionarioIds" />
            </Grid>
        </Grid>
    )
}

export default function NovoRelatorioEspelhoPeriodo() {
    const { mutateAsync, isLoading } = espelhoPeriodo.mutations.useCreate({
        invalidateQuery: true,
    })
    const empresaId = useStore(state => state.companyId)

    const handleSubmit: SubmitHandler<CreateEspelhoPeriodo> = async data =>
        mutateAsync(
            { ...data, empresaId },
            {
                onSuccess: () => {
                    toast.success(
                        'Relatório em processamento — avisaremos quando estiver pronto',
                    )
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )

    return (
        <Dialog.Root
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['create', 'EspelhoPontoPorPeríodo'])}
            schema={CreateEspelhoPeriodoSchema}
            defaultValues={{ formato: 'zip' }}
        >
            <Dialog.Title>Gerar espelho de ponto por período</Dialog.Title>
            <Dialog.Content>
                <Formulario />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit>
                    Gerar
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
